// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"TestInformation_mainContainer__33GXp"};